import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito diagnóstico médico para usarlo?',
    a: 'No. El Tomo 1 incluye un Test de Diagnóstico Personal para identificar tu perfil y empezar el plan correspondiente.'
  }, {
    q: '¿Tengo que comprar productos importados?',
    a: 'No. Todo está adaptado al mercado argentino con marcas reales de Carrefour, Coto y almacenes de barrio.'
  }, {
    q: '¿Cuánto tarda en funcionar?',
    a: 'Sentís alivio en la presión abdominal en las primeras 48 horas (Protocolo Tomo 1). Los resultados visibles y la regularidad definitiva se consolidan entre el día 3 y el día 14.'
  }, {
    q: '¿Es 100% digital?',
    a: 'Sí. Acceso inmediato por email en menos de 5 minutos. Podés leerlo en el celular o imprimirlo.'
  }, {
    q: '¿Funciona si tengo más de 65 años?',
    a: 'Sí. Fue diseñado específicamente para los cambios digestivos de la mujer de +55 años.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-brand-black" data-id="element-95">
      <div className="container mx-auto px-4" data-id="element-96">
        <div className="max-w-3xl mx-auto" data-id="element-97">
          <div className="text-center mb-12" data-id="element-98">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-99">
              ❓PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-100">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-800 rounded-xl overflow-hidden bg-brand-dark" data-id="element-101">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-102">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-103">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-104" />
                </button>
                <AnimatePresence data-id="element-105">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-106">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50 mt-2" data-id="element-107">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}